/**
 * POS offline sale queue — disabled in Electron desktop until explicitly re-enabled.
 * Web POS keeps offline queue for brief network outages.
 */
export function isPosOfflineModeEnabled(): boolean {
  const api = (window as Window & { electronAPI?: { isElectron?: boolean } }).electronAPI;
  return !api?.isElectron;
}
